<script setup lang="ts">
import type { CheckboxDomProps, CheckboxProps } from '@formwerk/core'
import { useCheckbox } from '@formwerk/core'

const props = defineProps<CheckboxProps<string>>()

const { inputProps, isChecked } = useCheckbox(props)

const buttonProps = computed(() => inputProps.value as CheckboxDomProps)
</script>

<template>
  <button
    v-bind="buttonProps"
    class="checkboxButton cursor-pointer aria-disabled:opacity-50 aria-disabled:cursor-not-allowed"
  >
    <span
      class="typo-sans-1 py-1.5 motion-base border border-$primary-color rounded-2.5 w-12 inline-block @hover:c-$negative-color focus-within:c-$negative-color focus-within:bg-$primary-color hover:bg-$primary-color"
      :class="isChecked ? 'c-$negative-color bg-$primary-color' : 'bg-white'"
    >
      <Text :text="label" />
    </span>
  </button>
</template>
